import React from "react"
import { useSelector, shallowEqual } from "react-redux"
import RecentTransaction from "./RecentTransaction";
import ReservedAccount from "./ReservedAccount";
import TransactionChart from "./TransactionChart"
import {formatDate, permissionAllow} from "../../../../../../../../../util/Helpers"
import WireAccountDetails from "./WireAccountDetails";
import { Permissions } from "../../../../../../../../../util/Permissions";
import LockedBalances from "./LockedBalances";
import AiAccountReview from "./AiAccountReview";

const Overview = props => {

    const adminUser = useSelector(state => state.auth.user);
    const { userId, accountId } = props.match.params;
    /* Get Account details from redux */
    const accountDetails = useSelector(({selectedUser}) => {
        return selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details;
    }, shallowEqual);
    const isTroveNextAccount =
        !!(accountDetails?.meta?.troveNextProfileId || accountDetails?.troveNextProfileId)
        || accountDetails?.userType === "MINOR";
    const userTypeLabel = accountDetails?.userType?.replace(/_/g, " ") || "-";
    // meta.beneficiaryName is where the minor's real name lives on a Trove Next
    // (custodial) account - confirmed against a live account response elsewhere
    // in this codebase (see AccountList's getTroveNextBeneficiaryName). Only show
    // this row when there's actually a Trove Next account AND a beneficiary name
    // to display; otherwise it shouldn't render at all.
    const beneficiaryName =
        accountDetails?.meta?.beneficiaryName
        || accountDetails?.beneficiaryName
        || "";

    return <>
                <div className="row">
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b card-stretch">
                            <div className="card-header h-auto border-0">
                                {/* <!--begin::Title--> */}
                                <div className="card-title py-5">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark font-weight-bolder">Account Details</span>
                                        <span className="d-block text-muted mt-2 font-size-sm">Trading Account Information</span>
                                    </h3>
                                </div>
                                {/* <!--end::Title--> */}
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mt-0">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Id</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails.accountId}</span>
                                    </div>

                                    {
                                        (accountDetails?.partner?.toLowerCase() === "sigma" || accountDetails?.meta?.cscsNo || accountDetails?.meta?.chnNo) ?
                                            <>
                                                {/* <!--begin::Field--> */}
                                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">CSCS Number</span>
                                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails?.meta?.cscsNo ?? "Nil"}</span>
                                                </div>
                                                {/* <!--begin::Field--> */}
                                                {/* <!--begin::Field--> */}
                                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">CHN Number</span>
                                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails?.meta?.chnNo ?? "Nil"}</span>
                                                </div>
                                                {/* <!--begin::Field--> */}
                                            </>
                                            :
                                            <>
                                                {/* <!--begin::Field--> */}
                                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Number</span>
                                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails.accountNumber}</span>
                                                </div>
                                                {/* <!--begin::Field--> */}
                                            </>
                                    }
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">User Type</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {isTroveNextAccount ? `${userTypeLabel} (Next Gen)` : userTypeLabel}</span>
                                    </div>
                                    {isTroveNextAccount && beneficiaryName && (
                                        <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                            <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Beneficiary</span>
                                            <span className="text-muted font-weight-bold font-size-sm my-1"> {beneficiaryName}</span>
                                        </div>
                                    )}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Status</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails.status?.toUpperCase()}</span>
                                    </div>
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Partner</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">  {accountDetails.partner}</span>
                                    </div>
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Currency</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {accountDetails.currency}</span>
                                    </div>
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Created</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1"> {formatDate(accountDetails.created)}</span>
                                    </div>
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Last Updated</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">  {formatDate(accountDetails.updated)}</span>
                                    </div>
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                    
                    </div>
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b  card-stretch">
                            <div className="card-header h-auto border-0">
                                {/* <!--begin::Title--> */}
                                <div className="card-title py-5">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark font-weight-bolder">Recent Stats</span>
                                        <span className="d-block text-muted mt-2 font-size-sm">Transactions for the last six months</span>
                                    </h3>
                                </div>
                                {/* <!--end::Title--> */}
                            </div>
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2 px-1">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column my-5">
                                    
                                    <TransactionChart transactions={accountDetails.transactions} currency={accountDetails.currency} />
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}

                        
                    </div>
                </div>
                <AiAccountReview userId={userId} accountId={accountId} />
                <LockedBalances balances={accountDetails?.lockedBalance ?? []} currency={accountDetails?.currency} />
                <RecentTransaction {...props} transactions={accountDetails.transactions} currency={accountDetails.currency} />
                <WireAccountDetails wireAccount={accountDetails.wireAccount} accountNumber={accountDetails.accountNumber} />
                { permissionAllow(adminUser, Permissions.NUBANS) && <ReservedAccount {...props} nubans={accountDetails.nubans} /> }

                
            </>
    
}

export default Overview;
